<div fxLayout="row" fxLayoutAlign="space-around" class="pt-20">
    <mat-card appearance="outlined" fxFlex="50%" style="padding: 10px">
        <mat-card-title>
            <h2 fxFlex style="margin: 0">{{ "FLIGHTS.UPDATE.manageFlight" | translate }}</h2>
        </mat-card-title>
        <mat-card-content>
            @if (loading) {
                <div class="content" fxLayout="row" fxFlexFill fxLayoutAlign="space-around center">
                    <p fxFlex>Loading....</p>
                </div>
            }
            @if (!loading) {
                <div class="content">
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
                        <div fxFlex></div>
                        <div fxFlex style="text-align: right">
                            <mat-form-field [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.flightStatus" | translate }}</mat-label>
                                <mat-select [(ngModel)]="flightStatus">
                                    <mat-option [value]="1">{{ "FLIGHTS.UPDATE.ok" | translate }}</mat-option>
                                    <mat-option [value]="2">{{ "FLIGHTS.UPDATE.pending" | translate }}</mat-option>
                                    <mat-option [value]="3">{{ "FLIGHTS.UPDATE.cancelled" | translate }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- <hr /> -->
                    <form #flightForm="ngForm" (ngSubmit)="onFormSubmit()" [formGroup]="flightFormGroup">
                        <app-form-group-title [title]="'FLIGHTS.UPDATE.departure' | translate"></app-form-group-title>
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px" class="pt-10">
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.flightDate" | translate }}</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="flightDatePicker"
                                    [placeholder]="'FLIGHTS.UPDATE.flightDate' | translate"
                                    name="flightDate"
                                    formControlName="flightDate"
                                />
                                <mat-datepicker-toggle matSuffix [for]="flightDatePicker"> </mat-datepicker-toggle>
                                <mat-datepicker #flightDatePicker></mat-datepicker>
                                @if (flightFormGroup.controls["flightDate"].hasError("matDatepickerParse")) {
                                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (flightFormGroup.controls["flightDate"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.departureTime" | translate }}</mat-label>
                                <input
                                    matInput
                                    id="departureTime"
                                    [placeholder]="'FLIGHTS.UPDATE.departureTimePlaceholder' | translate"
                                    name="departureTime"
                                    formControlName="departureTime"
                                />
                                @if (flightFormGroup.controls["departureTime"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                                @if (flightFormGroup.controls["departureTime"].hasError("pattern")) {
                                    <mat-error> {{ "GENERAL.hoursPatternError" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <app-airport-autocomplete-search
                                fxFlex
                                [controlName]="'departurePlace'"
                                label="FLIGHTS.UPDATE.departurePlace"
                                placeholder="FLIGHTS.UPDATE.selectDeparturePaceholder"
                                [formGroupElement]="flightFormGroup"
                                [appearanceType]="appearanceType"
                                (onAirportOptionSelectedChange)="flightFormGroup.get('departureId').setValue($event)"
                            >
                            </app-airport-autocomplete-search>
                        </div>
                        <app-form-group-title [title]="'FLIGHTS.UPDATE.arrival' | translate"></app-form-group-title>
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-10">
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.arrivalDate" | translate }}</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="arrivalDateDatePicker"
                                    [min]="minArrivalDate"
                                    [placeholder]="'FLIGHTS.UPDATE.arrivalDate' | translate"
                                    name="arrivalDate"
                                    formControlName="arrivalDate"
                                />
                                <mat-datepicker-toggle matSuffix [for]="arrivalDateDatePicker"> </mat-datepicker-toggle>
                                <mat-datepicker #arrivalDateDatePicker></mat-datepicker>
                                @if (flightFormGroup.controls["arrivalDate"].hasError("matDatepickerParse")) {
                                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (flightFormGroup.controls["arrivalDate"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.arrivalTime" | translate }}</mat-label>
                                <input
                                    matInput
                                    id="arrivalTime"
                                    [placeholder]="'FLIGHTS.UPDATE.arrivalTimePlaceholder' | translate"
                                    name="arrivalTime"
                                    formControlName="arrivalTime"
                                />
                                @if (flightFormGroup.controls["arrivalTime"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                                @if (flightFormGroup.controls["arrivalTime"].hasError("isBeforeError")) {
                                    <mat-error> {{ "FLIGHTS.UPDATE.isBeforeError" | translate }}</mat-error>
                                }
                                @if (flightFormGroup.controls["arrivalTime"].hasError("pattern")) {
                                    <mat-error> {{ "GENERAL.hoursPatternError" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <app-airport-autocomplete-search
                                fxFlex
                                [controlName]="'arrivalPlace'"
                                label="FLIGHTS.UPDATE.arrivalPlace"
                                placeholder="FLIGHTS.UPDATE.selectArrivalPaceholder"
                                [formGroupElement]="flightFormGroup"
                                [appearanceType]="appearanceType"
                                (onAirportOptionSelectedChange)="flightFormGroup.get('arrivalId').setValue($event)"
                            >
                            </app-airport-autocomplete-search>
                        </div>
                        <app-form-group-title [title]="'FLIGHTS.UPDATE.pilotCoPilot' | translate"></app-form-group-title>
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-10">
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.pilot" | translate }} </mat-label>
                                <mat-select name="pilotId" formControlName="pilotId">
                                    <mat-optgroup [label]="'FLIGHTS.UPDATE.pilot' | translate">
                                        @for (pilot of pilotArray; track pilot) {
                                            <mat-option [value]="pilot.id">
                                                {{ pilot.name }}
                                            </mat-option>
                                        }
                                    </mat-optgroup>
                                </mat-select>
                                @if (flightFormGroup.controls["pilotId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.pilotRole" | translate }} </mat-label>
                                <mat-select name="pilotRoleId" formControlName="pilotRoleId">
                                    @for (role of pilotRoles; track role) {
                                        <mat-option [value]="role.id"> {{ role.abbreviation }} - ({{ role.name }}) </mat-option>
                                    }
                                </mat-select>
                                @if (flightFormGroup.controls["pilotRoleId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.coPilot" | translate }}</mat-label>
                                <input
                                    type="text"
                                    [placeholder]="'FLIGHTS.UPDATE.selectCoPilotPaceholder' | translate"
                                    matInput
                                    name="coPilotName"
                                    formControlName="coPilotName"
                                    [matAutocomplete]="autoPilot"
                                />
                                <mat-autocomplete autoActiveFirstOption #autoPilot="matAutocomplete">
                                    @for (option of filteredPilotOptions | async; track option) {
                                        <mat-option [value]="option">
                                            {{ option }}
                                        </mat-option>
                                    }
                                </mat-autocomplete>
                                @if (flightFormGroup.controls["coPilotName"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.coPilotRole" | translate }} </mat-label>
                                <mat-select name="coPilotRoleId" formControlName="coPilotRoleId">
                                    @for (role of pilotRoles; track role) {
                                        <mat-option [value]="role.id"> {{ role.abbreviation }} - ({{ role.name }}) </mat-option>
                                    }
                                </mat-select>
                                @if (flightFormGroup.controls["coPilotRoleId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <app-form-group-title [title]="'FLIGHTS.UPDATE.helicopter' | translate"></app-form-group-title>
                        <div fxLayout=" column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-10">
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.helicopter" | translate }} </mat-label>
                                <mat-select name="helicopterId" formControlName="helicopterId">
                                    <mat-optgroup [label]="'FLIGHTS.UPDATE.helicopter' | translate">
                                        @for (helicopter of helicopterArray; track helicopter) {
                                            <mat-option [value]="helicopter.id">
                                                {{ helicopter.name }}
                                            </mat-option>
                                        }
                                    </mat-optgroup>
                                </mat-select>
                                @if (flightFormGroup.controls["helicopterId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.flightType" | translate }} </mat-label>
                                <mat-select name="flightTypeId" formControlName="flightTypeId">
                                    <mat-optgroup [label]="'FLIGHTS.UPDATE.flightType' | translate">
                                        @for (type of flightAttr?.flightTypes; track type) {
                                            <mat-option [value]="type.id">
                                                {{ type.name }}
                                            </mat-option>
                                        }
                                    </mat-optgroup>
                                </mat-select>
                                @if (flightFormGroup.controls["flightTypeId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.passengers" | translate }}</mat-label>
                                <input matInput type="number" [placeholder]="'FLIGHTS.UPDATE.passengers' | translate" name="passengers" formControlName="passengers" />
                                @if (flightFormGroup.controls["passengers"].hasError("required")) {
                                    <mat-error>
                                        {{ "GENERAL.required" | translate }}
                                    </mat-error>
                                }
                                @if (flightFormGroup.controls["passengers"].hasError("min")) {
                                    <mat-error>
                                        {{ "GENERAL.negativeValueErrorMsg" | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.duration" | translate }}</mat-label>
                                <input matInput [placeholder]="'FLIGHTS.UPDATE.duration' | translate" name="duration" formControlName="duration" />
                                @if (flightFormGroup.controls["duration"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <app-form-group-title [title]="'FLIGHTS.UPDATE.client' | translate"> </app-form-group-title>
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-10">
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.clientName" | translate }}</mat-label>
                                <input matInput [placeholder]="'FLIGHTS.UPDATE.clientName' | translate" name="clientName" formControlName="clientName" />
                                @if (flightFormGroup.controls["clientName"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <app-form-group-title [title]="'FLIGHTS.UPDATE.flightPilotNotes' | translate"> </app-form-group-title>
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-10">
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.notes" | translate }}</mat-label>
                                <textarea matInput name="notes" formControlName="notes" rows="6"></textarea>
                                <mat-hint>{{ "FLIGHTS.UPDATE.notesHelpText" | translate }}</mat-hint>
                            </mat-form-field>
                            @if (flightFormGroup.controls["notes"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                            <mat-form-field fxFlex [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.UPDATE.pilotNotes" | translate }}</mat-label>
                                <textarea matInput name="pilotNotes" formControlName="pilotNotes" rows="6"></textarea>
                                <mat-hint>{{ "FLIGHTS.UPDATE.pilotNoteHelpText" | translate }}</mat-hint>
                            </mat-form-field>
                            @if (flightFormGroup.controls["pilotNotes"].hasError("required")) {
                                <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                            }
                        </div>
                    </form>
                </div>
            }
        </mat-card-content>
        @if (!loading) {
            <mat-card-actions style="text-align: right; display: block">
                <button mat-raised-button color="primary" (click)="flightForm.ngSubmit.emit()">
                    {{ "GENERAL.save" | translate }}
                </button>
            </mat-card-actions>
        }
    </mat-card>
</div>
